import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";
import { DEFAULT_TEMPLATES } from "@/lib/messages";

export const Route = createFileRoute("/_authenticated/super-admin/message-templates")({
  head: () => ({
    meta: [
      { title: "Platform message templates · Landoo Super Admin" },
      {
        name: "description",
        content: "Default business message templates offered to every partner.",
      },
    ],
  }),
  component: () => (
    <DashboardShell title="Platform message templates" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <p className="text-sm text-muted-foreground">
        These defaults are offered to every partner. Partners may override the wording for their own
        account.
      </p>
      <div className="mt-4 grid gap-3 md:grid-cols-2">
        {DEFAULT_TEMPLATES.map((t) => (
          <div key={t.slug} className="rounded-2xl border border-border bg-card p-4 shadow-soft">
            <div className="text-sm font-bold text-brown-dark">{t.name}</div>
            <p className="mt-1 whitespace-pre-wrap text-xs text-muted-foreground">{t.body}</p>
          </div>
        ))}
      </div>
      <div className="mt-6">
        <PlaceholderCard
          title="Template governance"
          description="Editing platform defaults and approving partner overrides is coming soon."
        />
      </div>
    </DashboardShell>
  ),
});
